import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Agenda\FetchUnplannedEventsController::__invoke
* @see app/Http/Controllers/Agenda/FetchUnplannedEventsController.php
* @route '/api/agenda/fetch-unplanned-events'
*/
const FetchUnplannedEventsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchUnplannedEventsController.url(options),
    method: 'post',
})

FetchUnplannedEventsController.definition = {
    methods: ["post"],
    url: '/api/agenda/fetch-unplanned-events',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Agenda\FetchUnplannedEventsController::__invoke
* @see app/Http/Controllers/Agenda/FetchUnplannedEventsController.php
* @route '/api/agenda/fetch-unplanned-events'
*/
FetchUnplannedEventsController.url = (options?: RouteQueryOptions) => {
    return FetchUnplannedEventsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Agenda\FetchUnplannedEventsController::__invoke
* @see app/Http/Controllers/Agenda/FetchUnplannedEventsController.php
* @route '/api/agenda/fetch-unplanned-events'
*/
FetchUnplannedEventsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchUnplannedEventsController.url(options),
    method: 'post',
})

export default FetchUnplannedEventsController